export default __webpack_public_path__ + "static/media/regulatory--no-straight-through--g1.6fe4bf6d.png";